import { createFileRoute } from '@tanstack/react-router'
import CatalogoPage from '@/pages/dashboard/catalogo-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/catalogo/',
)({
  component: CatalogoPage,
})
